'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'tent';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e57d';
var svgPathData = 'M58.8 210.1l-23.3 237.9 204.7 0 0-368.5-166.9 106.7c-8.3 5.3-13.7 14.1-14.6 23.8zM272.2 80.7l0 154.6 136.7 212.7 68 0-23.2-237.8c-1-9.8-6.4-18.6-14.7-23.9L272.2 80.7zm0 213.7l0 153.5 98.7 0-98.7-153.5zM3.7 444.9L26.9 206.9c1.9-19.5 12.7-37.1 29.2-47.7L229.3 48.5c15.7-10 35.8-10.1 51.5-.1L456.1 159.3c16.7 10.6 27.5 28.2 29.5 47.8l23.2 237.8c1.8 18.8-12.9 35.1-31.8 35.1L35.5 480c-18.9 0-33.7-16.3-31.8-35.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTent = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;